import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { WelcomeVideoLinkModel } from '@app-config/models/welcome-video-link-model';
import { MediaGalleryService } from '@media/components/media-gallery/services/media-gallery.service';
import { AssetType } from '@media/enums/asset-type.enum';
import { RecordType } from '@media/enums/record-type.enum';
import { VideoType } from '@media/enums/video-type.enum';
import { Video } from '@media/models/video';
import { of } from 'rxjs';
import { RpcIconComponent } from '../../../../../core-modules/utils/rpc-icon/rpc-icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'welcome-video-link',
    templateUrl: './welcome-video-link.component.html',
    styleUrls: ['./welcome-video-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RpcIconComponent, TranslateModule]
})
export class WelcomeVideoLinkComponent {
    @Input() welcomeVideoLinkFeature: WelcomeVideoLinkModel;

    constructor(
        private readonly mediaGalleryService: MediaGalleryService,
    ) { }

    public openVideoInDialog(): void {
        const video: Video = {
            mediaId: 1,
            description: null,
            assetType: AssetType.Photo,
            recordType: RecordType.Listing,
            isPortrait: false,
            url: this.welcomeVideoLinkFeature.link,
            type: VideoType.Wellcomemat
        };

        this.mediaGalleryService.show({ videos$: of([video]) }, { customClass: 'kb-modal' });
    }
}
